import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "icn-hour-picker",
  templateUrl: "./hour-picker.component.html",
  styleUrls: ["./hour-picker.component.scss"],
})
export class HourPickerComponent {
  @Input() position: string;
  @Input() hour: number;
  @Input() posFixed = false;
  @Input() posTop = false;
  @Input() style: Record<string, string> | undefined;

  @Output() hourChange = new EventEmitter();

  hourChosen = -1;
  show = false;

  createArray() {
    let hours = [];
    for (let i = 0; i < 24; i++) {
      hours.push(i);
    }
    return hours;
  }

  onHourSelecting(hour) {
    this.hourChosen = hour;
  }

  onApply() {
    if (this.hourChosen === -1) return;
    this.hourChange.emit(this.hourChosen);
    this.close();
  }

  open() {
    this.show = true;
  }

  close() {
    this.show = false;
  }

  showHour() {
    if (!this.hour && this.hour !== 0) {
      return "---";
    } else {
      if (this.hour < 10) {
        return "0" + this.hour + ":00";
      } else {
        return "" + this.hour + ":00";
      }
    }
  }
}
